import React, {useState} from 'react';

const SelectDates = ({
    dates = [],
    onChange = items => console.log('No hay funcion', items)
}) => {
    const [selectedDate, setSelectedDate] = useState([]);

    const onSelectDate = (date) => {
       const isInList = selectedDate.find(item => item === date);

       const items = !isInList
            ? [...selectedDate, date]
            : selectedDate.filter(item => item !== date)

        setSelectedDate(items)
        onChange(items)
    }

    return <div className={'select-container'}>
            {
                dates.map((date, index) => {
                    const isInList = selectedDate.find(item => item === date);

                    return <div
                        className={`select-item ${!!isInList && 'selected-item'}`}
                        key={index}
                        onClick={() => onSelectDate(date)}
                    >
                        {date}
                    </div>
                })
            }
    </div>
}

export default SelectDates;